import { BusinessTypeEnum } from "@/types";

export type MemberFormData = {
  companyCode: string;
  corporateName: string;
  corporateCode?: string;
  series: string;
  business: string;
  representativePosition?: string;
  prefecture?: any;
  postCode?: string;
  address: string;
  phoneNumber?: string;
  email?: string;
  joiningDate?: string | null;
  unSubscribingDate?: string | null;
  storeName?: string;
  notes?: string;
  companyUser: {
    userRole?: string;
    userName: string;
    salesOffice?: string;
    post?: string;
    department?: string;
    phoneNumber?: string;
    email: string;
    password: string;
  };
};

export type NonMemberFormData = {
  companyCode: string;
  corporateCode?: string;
  corporateName: string;
  prefecture?: any;
  postCode?: string;
  address: string;
  phoneNumber?: string;
  email?: string;
  notes?: string;
  companyUser: {
    userName: string;
    email: string;
    phoneNumber?: string;
    password: string;
  };
};

export enum Role {
  MEMBER = BusinessTypeEnum.MEMBER,
  NON_MEMBER = BusinessTypeEnum.NON_MEMBER,
}

// Fix: Separate types for each role
export type MemberCompanyFormData = {
  role: Role.MEMBER;
  companyData: MemberFormData;
};

export type NonMemberCompanyFormData = {
  role: Role.NON_MEMBER;
  companyData: NonMemberFormData;
};

export type CreateCompanyFormData =
  | MemberCompanyFormData
  | NonMemberCompanyFormData;

// Types cho Edit mode - companyUser có thể undefined
export type EditMemberFormData = {
  companyCode: string;
  corporateName: string;
  corporateCode?: string;
  series: string;
  business: string;
  representativePosition?: string;
  prefecture?: any;
  postCode?: string;
  address: string;
  email?: string;
  phoneNumber?: string;
  joiningDate?: string | null; // field là optional, cũng có thể là null từ server
  unSubscribingDate?: string | null;
  storeName?: string;
  notes?: string;
};

export type EditNonMemberFormData = {
  companyCode: string;
  corporateCode?: string;
  corporateName: string;
  prefecture?: any;
  postCode?: string;
  address: string;
  email?: string;
  phoneNumber?: string;
  notes?: string;
};

export type EditMemberCompanyFormData = {
  role: Role.MEMBER;
  companyData: EditMemberFormData;
};

export type EditNonMemberCompanyFormData = {
  role: Role.NON_MEMBER;
  companyData: EditNonMemberFormData;
};

export type EditCompanyFormData =
  | EditMemberCompanyFormData
  | EditNonMemberCompanyFormData;
